import { ReturnIntegrationProviderSchema } from "@redotech/redo-model/return-integration-types";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const monitorSettingInputSchema = z.object({
  integration: ReturnIntegrationProviderSchema,
  active: z.boolean(),
  minProcessed: z.number().int().min(0),
  minProcessedDays: z.number().int().min(1),
  maxStaleRmas: z.number().int().min(0).nullish(),
});

export const saveReturnIntegrationMonitorSettings = unaryRpc({
  name: "saveReturnIntegrationMonitorSettings" as const,
  input: z.object({ settings: z.array(monitorSettingInputSchema) }),
  output: z.object({ success: z.boolean() }),
});

export type SaveReturnIntegrationMonitorSettingsInput = z.infer<
  typeof saveReturnIntegrationMonitorSettings.input
>;
export type SaveReturnIntegrationMonitorSettingsOutput = z.infer<
  typeof saveReturnIntegrationMonitorSettings.output
>;
